import styled from 'styled-components'
import { themeFontSize, themeColor } from '@elparking/components'

export default styled.span`
    line-height: 1.3em;
    font-size: ${themeFontSize('small')};
    margin-bottom: 0.5em;
    color: ${themeColor('red')}
`
